<template>
  <div class="col-xs-10 col-sm-10 grid_div" id="grid_right_div">
    <!--<div id="flushBtn"></div>-->
    <div id="contentDiv">
      <div class="body_content">
        <DashboardContentPC ref="contentRef"></DashboardContentPC>
      </div>
    </div>
  </div>
</template>

<script>
import {ref} from 'vue';
import {getContentSize} from './mainView';
import DashboardContentPC from "./dashboardContentPC.vue";
export default {
  name: "dashboard",
  components: {DashboardContentPC},
  data() {
    return {
      // contentRef: ref(null)
    }
  },
  mounted: function () {
    let this_ = this;
    this.$nextTick(function () {
      getContentSize()
    });
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboard.vue